import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { jackpotSchema } from '../types';

export const createDeleteJackpotMutation = () =>
	createAuthMutation({
		params: declareParams<number>(),
		request: {
			method: 'DELETE',
			url: (id) => `/jackpot/${id}`,
			body: {},
		},
		response: {
			contract: zodContract(jackpotSchema),
		},
	});
